<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="part-one-last-nights-witches-zooming-home-late">
<h1 style="margin-top:250px;font-family:Georgia;">Part One<br/> Last Night’s Witches (Zooming Home Late)</h1>
<p><em>
</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch005.vue?128d1fff